import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AppFacade } from 'ish-core/facades/app.facade';
import { ContentPageletView } from 'ish-core/models/content-view/content-view.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'custom-cms-quick-order-navigation-link',
  templateUrl: './cms-quick-order-navigation-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CmsQuickOrderNavigationLinkComponent {
  @Input() pagelet: ContentPageletView;
  isSticky$: Subscription;
  isSticky: boolean = false;

  constructor(private appfacade: AppFacade) {}
  ngOnInit() {
    this.isSticky$ = this.appfacade.stickyHeader$.subscribe((value: boolean) => {
      this.isSticky = value;
    });
  }
  ngOnDestroy() {
    // Unsubscribe from isSticky$ to avoid memory leaks
    this.isSticky$.unsubscribe();
  }
  manageLeft() {
    if (!SSR) {
      const div = document.getElementById('globalNavigation');
      const quickorderNav = document.getElementById('quickorder-nav');
      if (this.isSticky) {
        document.getElementById('quickorderFlyoutView').style.left = `${
          quickorderNav.getBoundingClientRect().left - div.getBoundingClientRect().left
        }px`;
      } else {
        document.getElementById('quickorderFlyoutView').style.left = `${0}px`;
      }
    }
  }
}
